import { Box, styled } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
}));
